import React, { Component } from "react";
import { Button, Form, Icon,Grid, Table, Card } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NotificationContainer, NotificationManager} from 'react-notifications';
import {password} from '../../herramientas/Forms'
import SiteWrapper from "../../SiteWrapper.react";
/**
 * Formularios
 */
//import { Usuario, Perfiles, Reporte } from "./Formularios/";

class FirstPassword extends Component {
  constructor(props) {
    super(props);
              this.state  = {
                             oldPassword    : '',
                             newPassword : '',
                             newPasswordC : '',
                             showQr: false,
                             qrImage: {},
              };

              this.passwordObj= {
                "oldPassword"  :  "",
                "newPassword"    :  ""
              }
              this.mensajePass=[];



  }
  selectedTab = (index) =>{
    this.setState({ currentTap:index })
  }

  /*
  P@miro92o1
  P4miro92-1
  */
  crud_putPassword() {
    this.getfuntion("put", this.passwordObj, "",  "usuarios/first_password", "contrana");
}


    getfuntion = (metodo = "get", obj = [], id = "", catalogo = "personas/plataforma/"+this.state.idPlataforma.value , stateVar = "personas" ) => {
           return Crud_Catalogos(metodo !== "post" && catalogo.includes("personas")? "personas":catalogo , "tracking", metodo, id, obj, "", stateVar  ).then((returnVal) => {
             switch (metodo) {
               case "put":
                 {
                   if (stateVar === "contrana") {
                    if(returnVal.status===200){
                      NotificationManager.success(returnVal.message, "Modificación");
                      this.setState({ showQr: true, qrImage: returnVal });
                    }else{
                      NotificationManager.error(returnVal.message, "Modificación");
                    }
                   }
                 }
                 break;
               default:
                 break;
             }
           }).catch(err => { console.log(err) });
      }

  changeNewPasswordC = (event) => this.setState({newPasswordC:event.target.value});

  changeNewPassword = (event) => {
    this.setState({newPassword:event.target.value});
    this.passwordObj.newPassword=event.target.value;
  }
  changeOldPassword = (event) => {
    this.setState({oldPassword:event.target.value});
    this.passwordObj.oldPassword=event.target.value;
  }


  render() {
    return (
      <SiteWrapper>
        <div className="container mt-3">
          <h2>¡Bienvenido !</h2>
          <p>
            Para garantizar la seguridad de tu cuenta, te pedimos que cambies tu contraseña predeterminada en tu primer inicio de sesión.
          </p>
          <p>Recuerda que tu contraseña es la llave de acceso a tu información. Te recomendamos que la mantengas en secreto y la cambies periódicamente para mayor seguridad.</p>
          {!this.state.showQr?
            <Card>
              <Card.Body>
                <Grid.Row>
                  <Grid.Col sm={12} md={12 } lg={4}>
                    <Form.Group label="Password Anterior">
                      <Form.Input name="oldPassword" type="password"  value={this.state.oldPassword}  onChange={this.changeOldPassword} />
                      </Form.Group>
                  </Grid.Col>
                  <Grid.Col sm={12} md={12 } lg={8}></Grid.Col>
                  <Grid.Col sm={12} md={ 4 } lg={ 4 }>
                    <Form.Group label="Nuevo Password">
                      <Form.Input name="newPassword" type="password"  value={this.state.newPassword} onChange={this.changeNewPassword} />
                      <div >{password(this.state.newPassword)}</div>
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col sm={12} md={12} lg={4}>
                      <Form.Group label="Confirmar Password">
                        <Form.Input name="newPasswordC" type="password"  value={this.state.newPasswordC} onChange={this.changeNewPasswordC} />
                        <div>{this.state.newPasswordC.length?this.state.newPasswordC===this.state.newPassword?"":"Las contraseñas no son iguales":""}</div>
                      </Form.Group>
                  </Grid.Col>
                </Grid.Row>
                <div className="float-right">
                        <Form.Group label="&nbsp;">
                        <Button target="_blank" size="sm" RootComponent="a" color="primary"
                        disabled= { this.habilitarBoton()}
                        onClick={() => this.crud_putPassword() }          >
                        <span className="badge"><Icon link={true} name="refresh-ccw" />{}</span>
                        </Button>
                        </Form.Group>
                  </div>
              </Card.Body>
            </Card>
            : null}
          { this.state.showQr && this.state.qrImage && this.state.qrImage.data?
            <Card>
              <Card.Header>{this.state.qrImage.message}</Card.Header>
              <Card.Body>
                <h5>Para garantizar la seguridad de tu cuenta, se a activado doble factor de autenticación</h5>
                <h5>Escanea el código en tu aplicación 2FA</h5>
                { !this.state.qrImage.data.mfaCode ?
                  <p className="alert alert-danger">{"Ha ocurrido un error"}</p>
                  : null
                }
                { this.state.qrImage.data.qrCode ?
                  <p>
                    <img
                      src={this.state.qrImage.data.qrCode}
                      style={{cursor: "not-allowed", pointerEvents: "none"}} alt="QR Code" />
                    <br/>{this.state.qrImage.data.mfaCode}
                  </p>
                  : null
                }
                <Button size="sm" color="success" onClick={() => { window.location.href = "/login"; }}>
                  <span className="badge">Listo</span>
                </Button>
              </Card.Body>
            </Card>
            : null
          }
        </div>
      </SiteWrapper>
    );
  }



habilitarBoton=()=> {
  //return this.passwordObj.newPasswordC !== this.passwordObj.newPassword && (!this.passwordObj.newPassword.length || !this.passwordObj.newPasswordC.length );
  if (!password(this.state.newPassword).length && this.state.newPassword===this.state.newPasswordC){
     return false;
  }
  return true;
}



}
export default FirstPassword;
